import { getCookie } from '../../utils/getCookie';

export const isAuthenticated = () => Boolean(getCookie('yandex_login'));

export function protect<TCallback extends Function>(
    callback: TCallback,
    retpath?: string,
): TCallback {
    return ((...args: unknown[]) => {
        if (!isAuthenticated()) {
            window.location.href = `${process.env.REACT_APP_PASSPORT_URL}/auth?retpath=${
                retpath ?? window.location.href
            }`;
        }

        return callback(...args);
    }) as any;
}
